import { useContext } from 'react';
import { CustomInitContext } from '@/components/CustomTravel/CustomInit';
import { useQuery } from '@/hooks/apollo/useQuery';
import { gql } from '@apollo/client';
import { CustomRecommendQuery, CustomRecommendQueryVariables } from '@/types/apollo';

const localQuery = gql`
  query customRecommend($countryCode: String!, $cityCodes: [String!]!) {
    customRecommend(countryCode: $countryCode, cityCodes: $cityCodes) {
      countryCode
      cityCodes
      name
      minOrder
      recommends {
        dayPeriod
        nightPeriod
        month
        minPrice
        maxPrice
        order
      }
    }
  }
`;

const useCustomRecommend = () => {
  const { overseasProduct } = useContext(CustomInitContext);
  const isMultiCountry = !!(
    !overseasProduct?.productFamily.visitAreas || (overseasProduct?.productFamily.visitAreas || []).length > 1
  );

  const { data, loading } = useQuery<CustomRecommendQuery, CustomRecommendQueryVariables>(localQuery, {
    variables: {
      countryCode: overseasProduct?.productFamily.visitAreas[0].countryCode || '',
      cityCodes: overseasProduct?.productFamily.visitAreas[0].cities.map((city) => city.cityCode) || [],
    },
    skip: isMultiCountry,
  });

  if (loading) return null;

  return data?.customRecommend;
};

export default useCustomRecommend;
